/**
 * 工單雙欄右欄 draft 群組 client 篩選。
 * - 物料（mtrNo／mtrName）命中 → 保留整組
 * - 僅庫編（stockNo）命中 → 群組保留、子項只留命中列
 */
export function filterDraftGroupsByKeyword(groups = [], keyword = '') {
  const q = String(keyword ?? '').trim().toLowerCase();
  if (!q) {
    return groups;
  }

  return groups
    .map((group) => {
      const mtrHit = [group.mtrNo, group.mtrName]
        .some((value) => String(value ?? '').toLowerCase().includes(q));
      if (mtrHit) {
        return group;
      }

      const matchedLines = (group.lines ?? []).filter(({ line }) => (
        String(line?.stockNo ?? '').toLowerCase().includes(q)
      ));
      if (matchedLines.length === 0) {
        return null;
      }
      return {
        ...group,
        lines: matchedLines,
      };
    })
    .filter(Boolean);
}
